import { type FC } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { UiButton, UiHStack, UiIconPlusCircle, UiStack, uiStyles, UiTag, UiText } from '@/lib/ui';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { type account } from '@/api';
import ResendInviteConfirmation from './ResendInviteConfirmation';

dayjs.extend(utc);

export interface AdminUserProps {
  adminUser: account.SearchAdminUsersResponseAdminUser
}

const AdminUser: FC<AdminUserProps> = ({
  adminUser,
}) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <>
      <UiButton variant={'ghost'} py={0} onClick={onToggle}>Resend invite</UiButton>
      <ResendInviteConfirmation
        isOpen={isOpen}
        onClose={onToggle}
        adminUser={adminUser}
      />
    </>
  );
};

export default AdminUser;
